module.exports = __webpack_public_path__ + "static/img/msgzs.bde7c6e0.png";